// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-reflexjs-gatsby-theme-base-src-pages-404-js": () => import("./../../../node_modules/@reflexjs/gatsby-theme-base/src/pages/404.js" /* webpackChunkName: "component---node-modules-reflexjs-gatsby-theme-base-src-pages-404-js" */),
  "component---node-modules-reflexjs-gatsby-theme-core-src-page-template-js": () => import("./../../../node_modules/@reflexjs/gatsby-theme-core/src/page-template.js" /* webpackChunkName: "component---node-modules-reflexjs-gatsby-theme-core-src-page-template-js" */)
}

